module.exports = __webpack_public_path__ + "static/media/editTopNav.89fa6ef9.svg";